import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { AccessToInformationOnEnvironmentAndItsProtectionRoutingModule } from './access-to-information-on-environment-and-its-protection-routing.module';
import { ATIOEAIPNewRequestComponent } from './new-request/new-request.component';
import { ATIOEAIPNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  declarations: [ATIOEAIPNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    AccessToInformationOnEnvironmentAndItsProtectionRoutingModule,
  ],
  providers: [ATIOEAIPNewRequestFormService],
})
export class AccessToInformationOnEnvironmentAndItsProtectionModule {}
